const getSiteName = (rootState) => rootState.site.siteName;

export default getSiteName;
